import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Loader2 } from 'lucide-react';
import { toLocalInput } from './taUtils';

export function CorrectTimeDialog({ activity, tz, onClose, onSubmit }) {
    const [field, setField] = useState('actual_start');
    const [value, setValue] = useState('');
    const [reason, setReason] = useState('');
    const [saving, setSaving] = useState(false);
    const isMs = activity && !activity.duration_min;

    useEffect(() => {
        if (!activity) return;
        const f = activity.actual_start ? 'actual_start' : 'actual_end';
        setField(isMs ? 'actual_end' : f);
        setValue(toLocalInput(activity[isMs ? 'actual_end' : f] || activity.actual_start, tz));
        setReason('');
    }, [activity, tz, isMs]);

    const pick = (f) => { setField(f); setValue(toLocalInput(activity[f] || activity.actual_start, tz)); };
    const submit = async () => {
        setSaving(true);
        try { await onSubmit({ field, value, reason }); } finally { setSaving(false); }
    };

    return (
        <Dialog open={!!activity} onOpenChange={(o) => !o && onClose()}>
            <DialogContent data-testid="ta-correct-dialog">
                <DialogHeader>
                    <DialogTitle>Corregir hora · {activity?.name}</DialogTitle>
                    <DialogDescription>La corrección queda en auditoría con el valor anterior, el nuevo y el motivo. Hora en zona {tz}.</DialogDescription>
                </DialogHeader>
                <div className="space-y-3">
                    {!isMs && (
                        <div className="flex gap-2">
                            <Button type="button" size="sm" variant={field === 'actual_start' ? 'default' : 'outline'} onClick={() => pick('actual_start')} data-testid="ta-correct-field-start">Inicio</Button>
                            <Button type="button" size="sm" variant={field === 'actual_end' ? 'default' : 'outline'} onClick={() => pick('actual_end')} data-testid="ta-correct-field-end">Fin</Button>
                        </div>
                    )}
                    <div className="space-y-1.5">
                        <Label>Nueva hora</Label>
                        <Input type="datetime-local" value={value} onChange={e => setValue(e.target.value)} data-testid="ta-correct-value" />
                    </div>
                    <div className="space-y-1.5">
                        <Label>Motivo (mínimo 10 caracteres)</Label>
                        <Textarea value={reason} onChange={e => setReason(e.target.value)} rows={3} placeholder="Ej.: se registró tarde por falta de señal en plataforma" data-testid="ta-correct-reason" />
                        <span className={`text-[10px] ${reason.trim().length >= 10 ? 'text-emerald-700 dark:text-emerald-400' : 'text-muted-foreground'}`}>{reason.trim().length}/10</span>
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Cancelar</Button>
                    <Button onClick={submit} disabled={saving || reason.trim().length < 10 || !value} data-testid="ta-correct-submit">
                        {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Guardar corrección
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
